import { useCallback, useState } from "react"

/**
 * The gutter a react-split pane pair resizes through. react-split builds the
 * gutter as a bare element, so the hook hands it a factory and keeps the
 * element it made, for `SplitGutterSeparator` to render the focusable
 * separator into.
 */
export function useSplitGutter() {
  const [gutter, setGutter] = useState<HTMLDivElement | null>(null)

  const createGutter = useCallback(() => {
    const element = document.createElement("div")
    element.className = "run-page-gutter gutter gutter-horizontal"
    setGutter(element)
    return element
  }, [])

  return { gutter, createGutter }
}
